<template>
  <v-row>
    <v-col class="pt-4">
      <v-row v-if="screen.logo_base64">
        <v-col
          class="py-0  d-flex justify-center"
          offset-sm="4"
          sm="4"
        >
          <v-img
            contain
            height="80pt"
            width="100pt"
            :src="'data:image/jpg;base64,'+screen.logo_base64"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="text-center pb-1">
          <span :style="`color: ${screen.text1.color};font-size: ${screen.text1.size}px`">
            {{ screen.text1.text }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center py-1">
          <span :style="`color: ${screen.text2.color}; font-size: ${screen.text2.size}px`">
            {{ this.screen.text2.text }}
          </span>
        </v-col>
      </v-row>
      <v-row>
        <v-col
          v-for="(nomenclature, idx) in catalog.nomenclatures"
          :key="idx"
          cols="12"
          sm="6"
        >
          <v-card>
            <v-row v-if="nomenclature.image.base64">
              <v-col
                class="py-0  d-flex justify-center"
              >
                <v-img
                  height="150pt"
                  width="100%"
                  :src="'data:image/jpg;base64,'+nomenclature.image.base64"
                />
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col
                class="py-0  d-flex justify-center"
                offset-sm="4"
                sm="4"
              >
                <v-img
                  :alt="nomenclature.name"
                  height="150pt"
                  width="100%"
                />
              </v-col>
            </v-row>
            <v-card-text :style="`background-color: ${catalogScreen.background};`">
              <v-row>
                <v-col class="pt-5 text-center">
                  <span :style="`color: ${catalogScreen.text1.color};font-size: ${catalogScreen.text1.size}px`">
                    {{ nomenclature.name }}
                  </span>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pt-4 text-center">
                  <span :style="`color: ${catalogScreen.text2.color};font-size: ${catalogScreen.text2.size}px`">
                    Цена: {{ Number(nomenclature.price).money() }}
                  </span>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions :style="`background-color: ${catalogScreen.background};`">
              <v-row class="d-flex justify-center">
                <v-col class="py-0">
                  <v-text-field
                    :style="`background-color: white;`"
                    class="tf-align-center"
                    :value="nomenclature.amount"
                    dense
                    hide-details
                    :hide-spin-buttons="true"
                    outlined
                    append-icon="mdi-plus"
                    prepend-inner-icon="mdi-minus"
                    type="number"
                    @click:append="onAddCounter(idx, nomenclature)"
                    @click:prepend-inner="onMinusCounter(idx, nomenclature)"
                  />
                </v-col>
                <v-col class="py-0">
                  <v-btn
                    width="100%"
                    cols="12"
                    :style="`color: ${screen.buttons.text.color}; background-color: ${screen.buttons.background}`"
                    @click="onAddToCart(nomenclature)"
                  >
                    <span
                      v-if="cartOfGoods.filter(f => f.nomenclatureId == nomenclature.id).length < 1"
                    >Добавить в корзину</span>
                    <span v-else>Убрать из корзины</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
            <v-card-actions :style="`background-color: ${catalogScreen.background};`">
              <v-row>
                <v-col class="py-4">
                  <!--                  :style="`color: ${screen.buttons.background}; outline-color: ${screen.buttons.background};outline-style: solid;`"-->
                  <v-btn
                    v-if="cartOfGoods.filter(f => f.nomenclatureId == nomenclature.id).length > 0"
                    :color="`${screen.buttons.background}`"
                    width="100%"
                    outlined
                    @click="onGotoToCart"
                  >
                    Перейти в корзину
                  </v-btn>
                  <v-btn
                    v-else
                    :ripple="false"
                    outlined
                    color="white"
                    width="100%"
                  >
                    Товар не выбран
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import { configuration } from "@/views/loyalty/models/justpay-configuration.model"

export default {
  name: 'ConfigurationCatalogScreen',
  props: {
    cart: Array,
    catalog: Object,
    catalogScreen: {
      type: Object,
      default: configuration.interface_description.first_screen
    },
    screen: {
      type: Object,
      default: configuration.interface_description.first_screen
    },
  },
  data: () => ({
    cartOfGoods: [],
  }),
  watch: {
    cart (newValue) {
      this.cartOfGoods = this.cart
    },
    deep: true,
  },
  mounted () {
    this.cartOfGoods = this.cart
  },
  methods: {
    onAddCounter (idx, nomenclature) {
      console.log('onAddCounter', idx)
      console.log('onAddCounter nomenclature', nomenclature)
      this.catalog.nomenclatures[idx].amount += 1
      if (this.cartOfGoods.length === 0) {
        this.cartOfGoods.push({
              amount: nomenclature.amount,
              cost: nomenclature.amount * nomenclature.price,
              nomenclatureId: nomenclature.id,
              nomenclatureName: nomenclature.name,
              // nomenclatureNumber: nomenclature.number,
              price: nomenclature.price,
              relayNumber: nomenclature.relayNumber,
              scenario: nomenclature.scenario,
              tax: nomenclature.tax
            })
      } else {
        this.cartOfGoods = this.cartOfGoods.map(c => {
          if (c.nomenclatureId === nomenclature.id) {
            c.amount += 1
            c.cost = c.amount * nomenclature.price
          }
          return c
        })
      }
      this.$emit('change', this.cartOfGoods)
    },
    onAddToCart (nomenclature) {
      console.log('onAddToCart catalog', this.catalog)
      console.log('onAddToCart nomenclature', nomenclature)
      if (this.cartOfGoods.filter(f => f.nomenclatureId == nomenclature.id).length === 0) {
        this.cartOfGoods.push({
          amount: nomenclature.amount,
          cost: nomenclature.amount * nomenclature.price,
          nomenclatureId: nomenclature.id,
          nomenclatureName: nomenclature.name,
          // nomenclatureNumber: nomenclature.number,
          price: nomenclature.price,
          relayNumber: nomenclature.relayNumber,
          scenario: nomenclature.scenario,
          tax: nomenclature.tax
        })
      } else {
        let i = 0
        while (i < this.cartOfGoods.length) {
          if (this.cartOfGoods[i].nomenclatureId === nomenclature.id) {
            this.cartOfGoods.splice(i, 1)
          } else {
            ++i
          }
        }
      }
      this.$emit('change', this.cartOfGoods)
    },
    onGotoToCart () {
      this.$emit('cart', this.cartOfGoods)
    },
    onMinusCounter (idx, nomenclature) {
      if (this.catalog.nomenclatures[idx].amount > 1) {
        this.catalog.nomenclatures[idx].amount -= 1
      }
      if (this.cartOfGoods.length > 0) {
        this.cartOfGoods = this.cartOfGoods.map(c => {
          if (c.nomenclatureId === nomenclature.id) {
            if (c.amount > 1) {
              c.amount -= 1
              c.cost = c.amount * nomenclature.price
            }
          }
          return c
        })
      }
      this.$emit('change', this.cartOfGoods)
    }
  }
}
</script>

<style>
.tf-align-center .v-text-field__slot textarea, .tf-align-center .v-text-field__slot input {
  text-align: center;
}

</style>
